import script from "./employee-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-report-table.vue?vue&type=script&setup=true&lang=js"

import "./employee-report-table.vue?vue&type=style&index=0&id=50028436&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50028436"]])

export default __exports__